import { MenuItem } from '../models/menu-item.class';

const dashboard: MenuItem = {
  text: 'Forside',
  link: '/',
  icon: 'home',
};

const membershipHeading: MenuItem = {
  text: 'Medlemskap',
  heading: true,
  subMenuOpen: true,
  subItems: [
    { text: 'Mitt medlemskap', link: '/mitt-medlemskap', cssClass: 'custom-membership-logo' },
    { text: 'Min kontingent', link: '/kontingent', icon: 'payments' },
    { text: 'Min fagforening', link: '/fagforening', cssClass: 'custom-union-logo' },
  ],
};

const workHeading: MenuItem = {
  text: 'Arbeidsforhold',
  heading: true,
  subMenuOpen: true,
  subItems: [
    { text: 'Mitt arbeidsforhold', link: '/mitt-medlemskap', cssClass: 'custom-membership-logo' },
    { text: 'Min tariffavtale', link: '/tariffavtale', cssClass: 'custom-collectiveagreement-logo' },
    { text: 'Min tillitsvalgt', link: '/tillitsvalgt', cssClass: 'custom-shopsteward-logo' },
  ],
};

const benefitsHeading: MenuItem = {
  text: 'Fordeler og støtte',
  heading: true,
  subMenuOpen: false,
  subItems: [
    { text: 'Forsikringer', link: '/forsikringer', cssClass: 'custom-insurance-logo' },
    { text: 'Stipend', link: '/stipend', icon: 'school' },
    { text: 'Reiseregninger', link: '/reiseregning', icon: 'commute' },
    { text: 'Rettigheter og fordeler', link: '/rettigheter-og-fordeler', icon: 'menu_book' },
  ],
};

const engagementHeading: MenuItem = {
  text: 'Engasjement',
  heading: true,
  subMenuOpen: false,
  subItems: [
    { text: 'Verving', link: '/verving', cssClass: 'custom-enlistment-logo' },
    { text: 'Kurs og konferanser', elink: 'https://www.fagforbundet.no/kurs-og-konferanser/', icon: 'event' },
  ],
};

export const menu: MenuItem[] = [dashboard, membershipHeading, workHeading, benefitsHeading, engagementHeading];
